import { request } from "./client";
import type {
  Timesheet,
  TimesheetActionResponse,
  ListTimesheetsResponse,
  TimesheetStatus,
  GenerateTimesheetsResponse,
  GenerateAllHistoryResponse,
} from "./types";

/** POST /api/v1/tawa/timesheets/{id}/submit. */
export async function submitTimesheet(
  timesheetId: string,
): Promise<TimesheetActionResponse> {
  return request<TimesheetActionResponse>({
    method: "POST",
    url: `/timesheets/${encodeURIComponent(timesheetId)}/submit`,
  });
}

/** POST /api/v1/tawa/timesheets/{id}/lock. */
export async function lockTimesheet(
  timesheetId: string,
): Promise<TimesheetActionResponse> {
  return request<TimesheetActionResponse>({
    method: "POST",
    url: `/timesheets/${encodeURIComponent(timesheetId)}/lock`,
  });
}

/** POST /api/v1/tawa/timesheets/{id}/reopen : refus : renvoie en brouillon. */
export async function reopenTimesheet(
  timesheetId: string,
  reason?: string,
): Promise<TimesheetActionResponse> {
  return request<TimesheetActionResponse>({
    method: "POST",
    url: `/timesheets/${encodeURIComponent(timesheetId)}/reopen`,
    ...(reason && reason.trim() ? { data: { reason: reason.trim() } } : {}),
  });
}

/** POST /api/v1/tawa/workers/timesheets/init : crée la feuille d'une période
 * (lundi-dimanche ou mois entier, selon le tenant). Soi-même, ou un worker
 * géré. Idempotent : une feuille existante est renvoyée telle quelle. */
export async function initTimesheet(
  workerUrl: string,
  periodStart: string,
  periodEnd: string,
): Promise<Timesheet> {
  return request<Timesheet>({
    method: "POST",
    url: "/workers/timesheets/init",
    data: {
      worker_url: workerUrl,
      period_start: periodStart,
      period_end: periodEnd,
    },
  });
}

/** POST /api/v1/tawa/admin/timesheets/generate : génère les drafts de tous les
 * workers ayant pointé sur la période (dates YYYY-MM-DD). Admin seul. */
export async function generateTimesheets(
  periodStart: string,
  periodEnd: string,
): Promise<GenerateTimesheetsResponse> {
  return request<GenerateTimesheetsResponse>({
    method: "POST",
    url: "/admin/timesheets/generate",
    data: { period_start: periodStart, period_end: periodEnd },
  });
}

/** POST /api/v1/tawa/admin/timesheets/generate-all : régénère tout l'historique. */
export async function generateAllHistory(): Promise<GenerateAllHistoryResponse> {
  return request<GenerateAllHistoryResponse>({
    method: "POST",
    url: "/admin/timesheets/generate-all",
  });
}

/** GET /api/v1/tawa/workers/timesheets?worker_url=&status=. */
export async function listWorkerTimesheets(
  workerUrl: string,
  status?: TimesheetStatus,
): Promise<ListTimesheetsResponse> {
  return request<ListTimesheetsResponse>({
    method: "GET",
    url: "/workers/timesheets",
    params: { worker_url: workerUrl, ...(status ? { status } : {}) },
  });
}
